module.exports = __webpack_public_path__ + "images/fifth_anniversary/campaign_FooterBanner_d6854bae61be4e9111cc33b323f0e6ad.png";